import {SandboxScenariosEnum} from '../../../libs/shared/core/src/models/api/sandboxTypes';

/*
 * Types.
 */

export {SandboxScenariosEnum} from '../../../libs/shared/core/src/models/api/sandboxTypes';

const scenarios = {
  [SandboxScenariosEnum.SCENARIO3_ACT1]: [
    'start-scenario-3-conversation-1',
    'acknowledge-message-prompt',
    'mention-marisa',
    'navigate-to-assigned-tab',
  ],
  [SandboxScenariosEnum.SCENARIO5_ACT1]: [
    'start-scenario-5-conversation-1',
    'acknowledge-message-prompt',
    'ticket-status-open',
    'mention-marisa',
    'ticket-status-resolved',
    'navigate-to-assigned-tab',
  ],
  [SandboxScenariosEnum.SCENARIO3_ACT2]: ['click-to-see-rules', 'rules-applied', 'complete-demo'],
  [SandboxScenariosEnum.SCENARIO3_ACT3]: ['start-scenario-3-conversation-3', 'complete-demo'],
  [SandboxScenariosEnum.SCENARIO4_ACT4]: [
    'start-scenario-4-conversation-4',
    'showcase-ai-answers',
    'showcase-automation',
    'wait-for-marisa',
    'complete-demo',
  ],
} as const;

export type StepSlug<T extends SandboxScenariosEnum> = (typeof scenarios)[T][number];
